import React, { useState, useEffect } from "react";
import MyOrders from "./pages/MyOrders";
import OrderTracking from "./pages/OrderTracking";
import HelpCenter from "./pages/HelpCenter";
import "./App.css";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import VendorDashboard from "./pages/VendorDashboard";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import Wishlist from "./pages/Wishlist";
import Profile from "./pages/Profile";
import Login from "./Login";
import Register from "./Register";
import BlouseCustomizer from "./pages/BlouseCustomizer";

import Footer from "./components/Footer";

function App() {
  // Check if there's a stored role and initialize accordingly
  const [currentPage, setCurrentPage] = useState(() => {
    const savedRole = localStorage.getItem("userRole");
    if (savedRole === "vendor") return "vendor";
    return "home";
  });
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");

  const handleLoginSuccess = (role) => {
    if (role === "vendor") {
      setCurrentPage("vendor");
    } else {
      setCurrentPage("home");
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userRole");
    localStorage.removeItem("user");
    setCurrentPage("home"); // or login
    alert("Logged out successfully");
  };

  const handleProductClick = (product) => {
    setSelectedProduct(product);
    setCurrentPage("detail");
  };

  const handleOrderClick = (orderId) => {
    setSelectedOrderId(orderId);
    setCurrentPage("tracking");
  };

  const handleSearch = (query) => {
    setSearchQuery(query);
    setCurrentPage("home"); // Reset to home to show search results
  };

  useEffect(() => {
    const handleClearSearch = () => {
      setSearchQuery("");
    };
    window.addEventListener("clearSearch", handleClearSearch);
    return () => window.removeEventListener("clearSearch", handleClearSearch);
  }, []);

  const renderPage = () => {
    switch (currentPage) {
      case "home":
        return (
          <Home onProductClick={handleProductClick} searchQuery={searchQuery} />
        );
      case "detail":
        return (
          <ProductDetail
            product={selectedProduct}
            onBack={() => setCurrentPage("home")}
          />
        );
      case "cart":
        return (
          <Cart
            onBack={() => setCurrentPage("home")}
            onGoToWishlist={() => setCurrentPage("wishlist")}
            onLoginClick={() => setCurrentPage("login")}
            onCheckout={() => setCurrentPage("myorders")}
          />
        );
      case "wishlist":
        return (
          <Wishlist
            onBack={() => setCurrentPage("home")}
            onProductClick={handleProductClick}
          />
        );
      case "vendor":
        return <VendorDashboard onLogout={handleLogout} />;
      case "customize":
        return <BlouseCustomizer onBack={() => setCurrentPage("home")} />;
      case "profile":
        return <Profile onLogout={handleLogout} onNav={setCurrentPage} />;
      case "login":
        return (
          <Login
            onLoginSuccess={handleLoginSuccess}
            onSwitchToRegister={() => setCurrentPage("register")}
          />
        );
      case "register":
        return <Register onSwitchToLogin={() => setCurrentPage("login")} />;
      case "myorders":
        return (
          <MyOrders
            onOrderClick={handleOrderClick}
            onGoShopping={() => setCurrentPage("home")}
          />
        );
      case "tracking":
        return (
          <OrderTracking
            orderId={selectedOrderId}
            onBack={() => setCurrentPage("myorders")}
          />
        );
      case "help":
        return <HelpCenter onBack={() => setCurrentPage("profile")} />;
      default:
        return (
          <Home onProductClick={handleProductClick} searchQuery={searchQuery} />
        );
    }
  };

  return (
    <div className="App">
      <Navbar
        onNavClick={setCurrentPage}
        userRole={localStorage.getItem("userRole")}
        onSearch={handleSearch}
      />
      <main className="main-content">{renderPage()}</main>
      <Footer />
    </div>
  );
}

export default App;
